<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="proTop d-flex j-sb a-start">
					<div class="ptLeft">
						<h3 class="font36 corfff h3">{{ $t('topMenu.frequentlyAskedQuestion') }}</h3>
					</div>
					<!-- 筛选 -->
					<div class="searchblock">
						<search search_type="faq" :isRederect="false" @search="handleSearch"></search>
					</div> 
				</div>
				 
				 <!-- 主体列表内容 -->
				 <div :class="['documentContent d-flex j-sb', {active: handleType}]">
					 <!-- 移动端显示分类 -->
					 <div class="handleType a-center j-center" @click="handleType = !handleType">{{ $t('show.category') }}<img src="@/assets/Icons/type.svg" alt="" /></div>
					 <!-- 左侧分类 -->
					 <div class="dcLeft">
						<div v-if="categoryTree.length>0">
							<div class="eltree bd10 font-light">
                            <h3 class="font18">{{$t('commom.productSeries')}}</h3>
                            <el-tree
                                :data="categoryTree"
                                empty-text=""
                                @check-change="checkChange"
                                show-checkbox
                                node-key="id"
                                ref="checkboxtree"
                                :expand-on-click-node="false"
                                :check-on-click-node="true"
                                :default-checked-keys="optionsSelect"
                                :props="defaultProps">
                            </el-tree>
                           </div>
						 </div>
					 </div>
					 <!-- 右侧列表 -->
					 <div class="proDocument proQuestion">
						 <div class="conmonDocument bd10">
							 <!-- 筛选 -->
							 <div class="filter d-flex j-sb a-center">
								 <div class="rForm d-flex a-center">
									 <div class="sort d-flex a-center">
										 
										 <select name="" v-model="pagination.orderBy" @change="handelSort" class="font-light">
												<option value="timeDesc">{{ $t('filter.bynew') }}</option>
												<option value="timeAsc">{{ $t('filter.byold') }}</option>
												<option value="titleDesc">{{$t('filter.bytitle')}}</option>
										 </select>
										 <img src="@/assets/Icons/sort.png" alt="">
									 </div>
									 <!-- <div class="search pr">
										 <input type="text" class="font-light" @keyup.enter="getFAQVOList" v-model="pagination.keyword" :placeholder="$t('filter.searchPlaceholder')">
										 <button class="pointer t-sion" @click="getFAQVOList">{{ $t('filter.search') }}</button>
									 </div> -->
								 </div>
								 <div class="showNums d-flex a-center font-light">
									 {{ $t('filter.page',{a:1,b:pagination.pageSize,c:total}) }}
									 <select name="" v-model="pagination.pageSize" @change="getFAQVOList" id="" class="font-light">
										<option value="10">{{ $t('filter.pageSize',{a:10}) }}</option>
										<option value="30">{{ $t('filter.pageSize',{a:30}) }}</option>
										<option value="50">{{ $t('filter.pageSize',{a:50}) }}</option>
										<option value="100">{{ $t('filter.pageSize',{a:100}) }}</option>
									 </select>
								 </div> 
							 </div>
							 <ul>
								 <li @click="goToPage('/questionDetail?id='+item.id)" :class="['d-flex j-sb a-center pointer', {haveImg: item.cover}]" v-for="(item, index) in FAQVOList" :key="index">
									 <figure class="pointer pr" v-if="item.cover">
										 <a href="javascript:;" class="ab"></a>
										 <img :src="item.cover" class="w100" alt="">
									 </figure>
									 <div class="pdLeft">
										 <h3 class="font18 pdf d-flex a-center"><a class="link">{{item.title}}</a><span  class="font-light  cor999">{{ item.releaseDate }}</span></h3>
										 <p class="cor999 font-light">{{item.description}}</p>
										 <div class="tagList d-flex f-wrap">
											<i class="font14" v-for="(item2, index2) in item.subGroup ? item.subGroup.split(',') : []" :key="index2">{{item2}}</i>
										 </div>
									 </div>
								 </li>
							 </ul>
						 </div>
						 <!-- 分页 -->
						<div class="pagination">
							 <el-pagination
								   @current-change="handleCurrentChange"
								   :page-size="10"
								   layout="prev, pager, next"
								   :total="total">
							</el-pagination>
						</div>
					 </div>
				 </div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  components: {
    
  },
  data() {
    return {
		// 控制移动端分类的显示/隐藏
		handleType: false,
		// 左侧分类
		leftMenu: [],
		// 左侧菜单选中
		leftMenuChecked: 1,
		// 常见问题
		FAQVOList: [],
		// 分页
		pagination: {
			pageNo: 1,
			pageSize: 10,
			keyword: '',
			orderBy:'timeDesc'
		},
		// 数量
		total: 0,
		categoryTree:[],//产品类别
		optionsSelect:[],
		defaultProps:{
			label:"name",
			children:"children"
		}
	}
  },
  
  created() {
	this.getCategory();
  	  // 获取培训
  	  this.getFAQVOList();
  },
  
  methods: {
	handleSearch(e){
		console.log(e)
		if(e.type=="faq"){
			if(!e.key) return;
			this.pagination.keyword=e.key;
			this.getFAQVOList();
		}else{
			this.$router.push({
				path:'/search',
				query:{
					type:e.type,
					kw:e.key
				}
			})
		};
	},
	getCategory(){//获取类别，初始产品列表
		this.$axios.get(`product/catalogue`)
		  .then(res => {
			  let data = res.data;
			  this.categoryTree = data;
			  this.selectAllIds=this.getChildIds({
				id:'',
				children:data
			  },[]);
			  this.selectTemp=this.selectAllIds;
		  })
		  .catch(err=>{})
	},
	checkChange(){
		var that=this;
		var nodes=that.$refs.checkboxtree.getCheckedNodes(true);
		that.optionsSelect=[];
		nodes.forEach(function(i){
			that.optionsSelect.push(i.id);
		});
		that.pagination.totalCategory=that.optionsSelect.join(',');
		that.getFAQVOList();
    },
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
		selectCategory(key,value){
		var that=this;
		if(that.pagination[key]==value){
			that.pagination[key]=''
		}else{
			that.pagination[key]=value
		}
		that.pagination.pageNo=1;
		that.getFAQVOList();
	},
	getCategory2(){
		var that=this;
		that.categoryKeys=[];
		this.$axios.get('knowledge/selectData')
		  .then(res => {
			  that.leftMenu = res.data;
			  Object.keys(that.leftMenu).forEach(function(key){
				if(!that.pagination[key]){
					that.$set(that.pagination,key,'');
					that.categoryKeys.push(key);
				}
			  });
		  })
		  .catch(err => {})
	},
	  // 获取列表
	  getFAQVOList() {
		  this.$axios.post('knowledge/FAQPage', this.pagination)
		  .then(res => {
			  this.FAQVOList = res.data.list;
			  this.total = res.data.total;
		  })
		  .catch(err => {})
	  },
	  
	  // 点击翻页
	  handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getFAQVOList();
	  },
	  handelSort(){
            this.pagination.pageNo=1;
            this.getFAQVOList();
        }
  }
}
</script>

<style lang="less" scoped>
	.eltree{
		padding: .3rem .2rem;
		h3{
			margin-bottom: .2rem;
		}
		/deep/ .el-tree-node__content{
			padding-bottom: .1rem;
			padding-top: .1rem;
			height: auto;
			background: none !important;
		}
		/deep/.is-checked>.el-tree-node__content{
			background: none;
			color: #2657db;
		}
		/deep/.el-tree-node__label{
			font-size: inherit;
			flex: 1 1 auto;
			padding-right: 1em;
			overflow: hidden;
			white-space: normal;
		}
		/deep/ .el-tree-node__expand-icon{
			position: absolute;
			right: 0;
		}
		/deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner{
			border-color: #2657db;
			background-color: #2657db;
		}
		@media (max-width: 1200px) {
			padding: .2rem;
		}
	}
	.proTop{
		padding: .5rem 0;
		.tags{
			span{
				display: inline-block;
				padding: 0.05rem 0.08rem;
				border-radius: 0.15rem;
				background: #5794f8;
				color: #fff;
				margin-right: .1rem;
			}
		}
		@media (max-width: 1200px) {
			display: block;
			.cTopFrom{
				margin: .3rem auto 0;
			}
		}
	}
	
	.proQuestion{
		figure{
			width: 2rem;
		}
	}
	
	.documentContent{
		.proDocument{
			width: 80%;
		}
		.dcLeft{
			width: 18.75%;
			dl{
				padding: .3rem;
				&:not(:last-child) {
					margin-bottom: .1rem;
				}
				dt{
					margin-bottom: .3rem;
				}
				ul li{
					&:not(:last-child) {
						margin-bottom: .2rem;
					}
					&:hover,&.active{
						a{
							color: #3076e3;
						}
						span{
							background: #2657db;
							color: #fff;
						}
					}
					a{
						display: block;
						max-width: 85%;
					}
					span{
						padding: 0 .07rem;
						height: .2rem;
						border-radius: .2rem;
						background: #e4eef6;
						color: #7cacd0;
						margin-left: .1rem;
						line-height: .2rem;
						margin-top: -2px;
					}
				}
			}
		}
		@media (max-width: 1200px) {
			position: relative;
			overflow: hidden;
			.dcLeft{
				position: absolute;
				left: -230px;
				top: 0;
				width: 230px;
				transition: all .5s;
				dl{
					padding: .2rem;
				}
			}
			.proDocument{
				width: 100%;
				transition: all .5s;
			}
			&.active{
				.dcLeft{
					left: 0;
				}
				.proDocument{
					transform: translateX(240px);
				}
			}
		}
	}
	
	.proDocument{
		.pdLeft{
			width: 100%;
			p{
				margin-top: .1rem;
			}
			.tagList{
				margin-top: .2rem;
			}
		}
		.conmonDocument{
			ul li{
				&.haveImg{
					h3{
						padding-left: 0;
						background: none !important;
						
					}
					.pdLeft{
						width: calc(100% - 2.2rem);
					}
				}
				h3{
					width: 100%;
					&.pdf{
						background: url(@/assets/Icons/questionIcon.png) no-repeat left center;
						background-size: auto 0.18rem;
						min-height: 0.18rem;
					}
					span {
					flex: 0 0 auto;
					padding-left: 2em;
					font-size: 0.8em;
					font-weight: normal;
					}
					a {
					flex: 1 1 auto;
					overflow: hidden;
					}
				}
			}
		}
		@media (max-width: 640px) {
			.conmonDocument{
				ul li{
					&.haveImg{
						flex-direction: column;
						.pdLeft,figure{
							width: 100%;
						}
						.pdLeft{
							margin-top: .2rem;
						}
					}
				}
			}
		}
	}
	
	.conmonDocument{
		padding: .3rem;
		.filter{
			margin-bottom: .4rem;
			.search{
				margin-left: .2rem;
				border-radius: 3px;
				border: solid 1px #eee;
				overflow: hidden;
				input{
					width: 2.8rem;
					padding: 0 .15rem;
					padding-right: .75rem;
				}
				button{
					position: absolute;
					right: 0;
					top: 0;
					width: .6rem;
					background: #2657db;
					color: #fff;
					&:hover{
						background: #003ee5;
					}
				}
				input,button{
					height: .33rem;
					font-size: .16rem;
				}
			}
			.sort{
				
				select{
					margin-right: .1rem;
					margin-left: 0;
				}
				img{
					width: .2rem;
				}
			}
			select{
				font-size: .16rem;
				width: 1.2rem;
				height: .35rem;
				border: solid 1px #eee;
				border-radius: 3px;
				padding-left: .15rem;
				margin-left: .2rem;
				background: url(@/assets/Icons/arrowDownGray.png) no-repeat 90% center/.15rem;
			}
		}
		ul li{
			padding: .25rem 0;
			&:not(:last-child) {
				border-bottom: solid 1px #f1f1f1;
			}
			h3{
				width: 85%;
			}
		}
		@media (max-width: 640px) {
			.filter{
				.rForm{
					display: block;
				}
				.search{
					margin: .2rem 0;
					input{
						width: calc(100% - .8rem);
						
					}
					button{
						width: .8rem;
					}
					input,button{
						height: .5rem;
						line-height: .5rem;
					}
				}
			}
			ul li{
				padding-right: 0;
			}
		}
	}
</style>
